import { createFileRoute } from '@tanstack/react-router';

import { OrgTeamPage } from '@/features/org/team-page';

export const Route = createFileRoute('/_app/org/$orgId/members')({
  component: RouteComponent,
});

function RouteComponent() {
  const { orgId } = Route.useParams();
  return <OrgTeamPage orgId={orgId} />;
}
